import React from 'react'
import { Link } from "gatsby"
import profilPic from "../assets/profil_pic_2.jpg"
import { IoLogoGithub } from "react-icons/io"
import { FaLinkedin, FaFacebook } from "react-icons/fa"


export default function Header() {
  return (
    <>
      <header className="header">
        <div className="row">
          <div className="col text">
            <h1 className="title">Pour une interface adaptée à vos clients</h1>
            <h2 className="subTitle">Bonjour, je suis Maxime BOUNAAS-FERRET, Développeur web React et spécialisé dans la conversion de trafic web.</h2>
            <div className="socials">
              <a href="https://github.com/MaximeBF2000" target="blank" className="social_icon" data-tooltip="Github"><IoLogoGithub /></a>
              <a href="https://www.facebook.com/Maxime-Bounaas-2057664100953835/" target="blank" className="social_icon" data-tooltip="Facebook"><FaFacebook /></a>
              <a href="https://www.linkedin.com/in/maximebounaasferret/" target="blank" className="social_icon" data-tooltip="LinkedIn"><FaLinkedin /></a>
            </div>
          </div>
          <div className="col img">
            <img src={profilPic} alt="Photo de profil de Maxime BOUNAAS-FERRET"/>
          </div>
        </div>
      </header>
      <svg  data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" ><path  d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill" fill="#FF5733" fillOpacity="1"></path></svg>
    </>
  )
}
